const HomeJsonLd = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '전립상회 PAC KOREA',
    url: siteUrl,
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/f709ae3db271d6c0d8bf92ab254501ef.png',
    },
    description:
      '전립상회 PAC KOREA는 박문수 원장이 직접 설계한 프로엑티브 시리즈를 판매하는 프리미엄 건강기능식품 브랜드입니다. HACCP·ISO 인증, 식약처 인증, GMP 공장 생산으로 품질을 보장합니다.',
    sameAs: ['https://smartstore.naver.com/proactivecare'],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+82-70-4312-4090',
      contactType: 'customer service',
      availableLanguage: 'Korean',
      hoursAvailable: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '선릉로 513 APEX 타워 3층',
      addressLocality: '강남구',
      addressRegion: '서울',
      addressCountry: 'KR',
    },
  };

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: '전립상회 PAC KOREA',
    url: siteUrl,
    image: 'https://static.readdy.ai/image/1b7d8ba0d33546c92bdd2a3ada1e3e7c/f709ae3db271d6c0d8bf92ab254501ef.png',
    description: '박문수 원장이 직접 설계한 프로엑티브 시리즈 전립선 건강기능식품 전문 브랜드. 식약처 인증·GMP·HACCP 인증.',
    telephone: '+82-70-4312-4090',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '선릉로 513 APEX 타워 3층',
      addressLocality: '강남구',
      addressRegion: '서울',
      postalCode: '06158',
      addressCountry: 'KR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 37.5045,
      longitude: 127.0490,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
    priceRange: '₩₩',
    currenciesAccepted: 'KRW',
    paymentAccepted: '신용카드, 네이버페이, 카카오페이',
    hasMap: 'https://maps.google.com/?q=서울+강남구+선릉로+513',
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '전립상회 PAC KOREA',
    url: siteUrl,
    description: '전립상회 PAC KOREA 공식 홈페이지 - 전립선 건강 프리미엄 건강기능식품 전문 브랜드',
    inLanguage: 'ko-KR',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteUrl}/product/{search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '전립상회 PAC KOREA 건강기능식품 제품 목록',
    url: `${siteUrl}/#products`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '프로엑티브 듀오',
        url: `${siteUrl}/product/1`,
        description: '두 가지 핵심 영양 성분을 하나에 담은 복합 건강기능식품',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '프로엑티브 오메가3',
        url: `${siteUrl}/product/2`,
        description: '고순도 EPA·DHA 오메가3 지방산 건강기능식품',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: '프로엑티브 릴랙스',
        url: `${siteUrl}/product/3`,
        description: '스트레스 완화와 수면의 질 개선을 지원하는 건강기능식품',
      },
      {
        '@type': 'ListItem',
        position: 4,
        name: '에이치씨에이 플러스',
        url: `${siteUrl}/product/4`,
        description: 'HCA 고함량 체지방 감소 및 체중 관리 건강기능식품',
      },
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '전립상회 PAC KOREA 제품은 어디서 구매할 수 있나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '네이버 스마트스토어(https://smartstore.naver.com/proactivecare)에서 구매하실 수 있습니다. 네이버페이 포인트 적립 및 다양한 할인 혜택을 제공합니다.',
        },
      },
      {
        '@type': 'Question',
        name: '프로엑티브 시리즈는 식약처 인증을 받은 제품인가요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '네, 전립상회 PAC KOREA의 프로엑티브 시리즈는 식약처 인증 건강기능식품이며, HACCP·ISO 인증 및 GMP 공장에서 생산됩니다.',
        },
      },
      {
        '@type': 'Question',
        name: '프로엑티브 듀오는 어떻게 섭취하나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '1일 1회, 1회 1정을 충분한 물(200ml 이상)과 함께 섭취하세요. 매일 일정한 시간에 섭취하면 더욱 효과적입니다.',
        },
      },
      {
        '@type': 'Question',
        name: '프로엑티브 오메가3는 어떻게 섭취하나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '1일 1회, 1회 1캡슐을 식후 충분한 물과 함께 섭취하세요. 식사 직후 섭취하면 흡수율이 높아집니다. 장용성 캡슐로 비린내 없이 편안하게 섭취할 수 있습니다.',
        },
      },
      {
        '@type': 'Question',
        name: '프로엑티브 릴랙스는 어떻게 섭취하나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '1일 2회, 1회 1정을 물과 함께 섭취하세요. 불면증이 있다면 저녁식사 후 2정을 한꺼번에 섭취하세요. 취침 1~2시간 전 섭취 시 더욱 효과적입니다.',
        },
      },
      {
        '@type': 'Question',
        name: '에이치씨에이 플러스는 어떻게 섭취하나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '1일 3회, 식사 30분 전 1포씩 물과 함께 섭취하세요. 규칙적인 운동과 균형 잡힌 식단과 함께 섭취 시 더욱 효과적입니다.',
        },
      },
      {
        '@type': 'Question',
        name: '건강기능식품이 의약품을 대체할 수 있나요?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '아니요, 건강기능식품은 의약품이 아니므로 질병의 예방 및 치료를 위한 의약품을 대체할 수 없습니다. 임산부, 약물 복용 중인 분은 의사 상담 후 섭취하세요.',
        },
      },
    ],
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '전립상회 PAC KOREA | 전립선 건강 프리미엄 건강기능식품',
    url: siteUrl,
    description: '전립상회 PAC KOREA 공식 홈페이지. 박문수 원장이 설계한 프로엑티브 시리즈 - 전립선 건강기능식품, 오메가3, 릴랙스, 체중관리. 식약처 인증·GMP 공장 생산.',
    inLanguage: 'ko-KR',
    isPartOf: {
      '@type': 'WebSite',
      name: '전립상회 PAC KOREA',
      url: siteUrl,
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '홈',
          item: siteUrl,
        },
      ],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
    </>
  );
};

export default HomeJsonLd;
